module.exports = __webpack_public_path__ + "img/icon-queue-upload.16b7e094.svg";